"use client";

import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";

import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";

import "./AppointmentModal.css";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { useNavigate } from "react-router-dom";
import { getDoctorSlots } from "../../../../features/doctor/doctorSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId, formatTime } from "../../../../utils/common";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../Loader/Loader";
import Lottie from "react-lottie";
import noDataAnimation from "../../../Animation/no_data/NoData.json";

export default function AppointmentModal({
  show,
  handleClose,
  doctor,
  ...props
}) {
  const [activeDate, setActiveDate] = useState(0);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount?.addMyaccount);

  const doctorSlots = useSelector((state) => state.doctor.doctorSlots);

  // useEffect(() => {
  //   dispatch(getDoctorSlots({ id: doctor?.id, date: "" }));
  // }, [dispatch, show, doctor?.id]);

  const navigate = useNavigate();

  const timeSlots = {
    Morning: [
      "09:00 AM",
      "09:30 AM",
      "10:00 AM",
      "10:30 AM",
      "11:00 AM",
      "11:30 AM",
      "12:00 AM",
    ],
    Afternoon: [
      "12:30 PM",
      "01:00 PM",
      "01:30 PM",
      "02:00 PM",
      "02:30 PM",
      "03:00 PM",
      "03:30 PM",
      "04:00 PM",
    ],
    Evening: [
      "04:30 PM",
      "05:00 PM",
      "05:30 PM",
      "06:00 PM",
      "06:30 PM",
      "07:00 PM",
      "07:30 PM",
      "08:00 PM",
    ],
  };

  const scheduleData = [
    {
      date: "Today",
      slots: {
        Morning: ["09:00 AM", "09:30 AM", "10:00 AM"],
        Afternoon: ["01:00 PM", "01:30 PM", "02:00 PM"],
        Evening: ["06:00 PM", "06:30 PM"],
      },
    },
    {
      date: "12 March",
      slots: {
        Morning: ["08:00 AM", "08:30 AM"],
        Afternoon: ["12:30 PM", "01:00 PM"],
        Evening: ["05:00 PM", "05:30 PM", "06:00 PM"],
      },
    },
    {
      date: "13 March",
      slots: {
        Morning: ["09:30 AM", "10:30 AM"],
        Afternoon: ["02:00 PM", "02:30 PM"],
        Evening: ["07:00 PM", "07:30 PM"],
      },
    },
  ];

  const handleDateSelect = (dateItem) => {
    setSelectedDate(dateItem);
  };

  const dates = Array.from({ length: 15 }, (_, index) => {
    const date = dayjs().add(index, "day");

    return {
      label: index === 0 ? "Today" : date.format("DD MMM"),
      value: date.format("YYYY-MM-DD"),
      day: date.format("ddd"),
    };
  });

  const [selectedDate, setSelectedDate] = useState(dates[0]);
  const [loading, setLoading] = useState(true);

  const fetchDoctor = async () => {
    try {
      setLoading(true);

      await dispatch(
        getDoctorSlots({
          id: doctor?.id,
          date: selectedDate.value,
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (doctor?.id) {
      fetchDoctor();
    } else {
      setLoading(false);
    }
  }, [dispatch, selectedSlot, selectedDate, show, doctor?.id]);

  const onClickContinue = () => {
    if (!selectedSlot) return;

    const appointment = {
      patient_id: user ? encodeId(user?.id) : "",
      doctor_id: encodeId(doctor?.id),
      appointment_date: selectedDate.value,
      slot_time: selectedSlot.slot_time,
      session_id: encodeId(selectedSlot.session_id),
      shift_id: encodeId(selectedSlot.shift_id),
      shift_name: selectedSlot.shift_name,
    };

    try {
      localStorage.setItem("appointmentDetails", JSON.stringify(appointment));
    } catch (error) {
      console.error("Error saving appointment:", error);
    }

    navigate("/payment");
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="xl"
        className="appointment_modal"
      >
        <Modal.Body>
          <div className="close_img_div">
            <img
              src="/assets/images/modal/close.png"
              className="close_img"
              onClick={handleClose}
              alt="Close"
            />
          </div>
          {loading ? (
            <>
              <Loader color={"#97ac2f"} />
            </>
          ) : (
            <>
              <div className="date_tabs_wrapper">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={5}
                  breakpoints={{
                    768: {
                      slidesPerView: 6,
                    },
                    992: {
                      slidesPerView: 8,
                    },
                  }}
                >
                  {dates.map((item) => (
                    <SwiperSlide key={item.value}>
                      <button
                        className={`date_tab_btn ${
                          selectedDate.value === item.value ? "active" : ""
                        }`}
                        onClick={() => {
                          setSelectedDate(item);
                          setSelectedSlot(null);
                        }}
                      >
                        <div>{item.label}</div>
                        <small>{item.day}</small>
                      </button>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="slot_wrapper">
                {doctorSlots?.length > 0 ? (
                  doctorSlots.map((shift) => (
                    <div className="slot_section" key={shift.shift_id}>
                      <h5 className="slot_title">{shift.shift_name}</h5>

                      <div className="slot_grid">
                        {shift.slots.length > 0 ? (
                          shift.slots.map((slot, index) => (
                            <button
                              key={index}
                              className={`time_btn ${
                                selectedSlot?.slot_time === slot.time
                                  ? "active"
                                  : ""
                              } ${!slot.available ? "disabled" : ""}`}
                              // onClick={() => {
                              //   if (!slot.available) return;
                              //   setSelectedTime(slot.time);
                              // }}

                              onClick={() => {
                                if (!slot.available) return;

                                setSelectedSlot({
                                  session_id: slot.session_id,
                                  slot_time: slot.time,
                                  shift_id: shift.shift_id,
                                  shift_name: shift.shift_name,
                                });
                              }}
                            >
                              {/* {!slot.available && (
                          <FontAwesomeIcon
                            icon={faBan}
                            className="me-2 text-danger"
                          />
                        )} */}
                              {formatTime(slot.time)}
                            </button>
                          ))
                        ) : (
                          <div className="text-center py-4">
                            No slots available in {shift.shift_name || "Here"}
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-slots-box">
                    <div className="no-slots-lottie">
                      <Lottie
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData: noDataAnimation,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid meet",
                          },
                        }}
                      />
                    </div>
                    <h4 className="no-slots-title">No slots available</h4>
                    <p className="no-slots-sub">
                      Please try selecting another date.
                    </p>
                  </div>
                )}
              </div>
              {/* <Button className="continue_btn">Continue</Button> */}
              {doctorSlots?.some((shift) => shift.slots?.length > 0) && (
              <div className="continue-btn-wrapper">
                {" "}
                {/* <Green_btn
              btnText="Continue"
              onClick={() => navigate("/payment")}
            /> */}
                <Green_btn
                  btnText="Continue"
                  // disabled={!selectedTime}
                  disabled={!selectedSlot}
                  onClick={onClickContinue}
                  // onClick={() =>
                  //   navigate("/payment", {
                  //     state: {
                  //       slot_time: selectedTime,
                  //     },
                  //   })
                  // }
                />
              </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
